export default __webpack_public_path__ + "static/feature-guestbook-cecf3b7e3cc6df3d3d925f1e75fe37d5.png";